import React from 'react';

// Per-command icons for the spotlight command rows. Style contract matches
// the data-row icons (table/column) authored directly in DiagramSearch.jsx:
// ~20px, fill/stroke rgb(134, 145, 148), className `command-icon-<name>`.

function PlusIcon() {
    // Moved verbatim from DiagramSearch.jsx — was the generic icon on every
    // command row; now scoped to 'new-table' only.
    return (
        <svg className="command-icon-plus" width="20px" height="20px" viewBox="0 0 24 24" strokeWidth="0.2px" stroke="black"><path d="M12,18c-0.6,0-1-0.4-1-1V7c0-0.6,0.4-1,1-1s1,0.4,1,1v10C13,17.6,12.6,18,12,18z" fill="rgb(134, 145, 148)"></path><path d="M17,13H7c-0.6,0-1-0.4-1-1s0.4-1,1-1h10c0.6,0,1,0.4,1,1S17.6,13,17,13z" fill="rgb(134, 145, 148)"></path></svg>
    );
}

function NewLineIcon() {
    // Path data from components/Icon's `LineIconNew` (used by ControlsLeft's
    // new-line button), restyled from dark fill to the grey row-icon style.
    return (
        <svg
            className="command-icon-new-line"
            width="18px"
            height="20px"
            viewBox="0 0 24 24"
            fill="none"
            transform="rotate(45)matrix(-1, 0, 0, -1, 0, 0)"
            style={{ marginLeft: '1px', marginRight: '1px' }}
        >
            <path
                d="M7.07615 16.6173C7.23093 16.2436 7.59557 16 8.00003 16H10.5V3C10.5 2.44772 10.9477 2 11.5 2H12.5C13.0523 2 13.5 2.44772 13.5 3V16H16C16.4045 16 16.7691 16.2436 16.9239 16.6173C17.0787 16.991 16.9931 17.4211 16.7071 17.7071L12.7071 21.7071C12.3166 22.0976 11.6834 22.0976 11.2929 21.7071L7.29292 17.7071C7.00692 17.4211 6.92137 16.991 7.07615 16.6173Z"
                fill="rgb(134, 145, 148)" stroke="rgb(25, 26, 27)"
            ></path>
        </svg>
    );
}

function NewAreaIcon() {
    // Path data from components/Icon's `TableGroupNewIcon` (used by
    // ControlsLeft's new-area button), restyled to the grey row-icon stroke.
    return (
        <svg
            className="command-icon-new-area"
            width="18px"
            height="20px"
            viewBox="0 0 256 256"
            fill="none"
            strokeWidth="15"
            stroke="rgb(134, 145, 148)"
            style={{ marginLeft: '1px', marginRight: '2px' }}
        >
            <path d="M148,40a4.0002,4.0002,0,0,1-4,4H112a4,4,0,0,1,0-8h32A4.0002,4.0002,0,0,1,148,40Zm-4,172H112a4,4,0,0,0,0,8h32a4,4,0,0,0,0-8ZM208,36H184a4,4,0,0,0,0,8h24a4.00458,4.00458,0,0,1,4,4V71.99951a4,4,0,0,0,8,0V48A12.01375,12.01375,0,0,0,208,36Zm8,71.99951a4.0002,4.0002,0,0,0-4,4v32a4,4,0,0,0,8,0v-32A4.0002,4.0002,0,0,0,216,107.99951Zm0,72a4.0002,4.0002,0,0,0-4,4V208a4.00458,4.00458,0,0,1-4,4H184a4,4,0,0,0,0,8h24a12.01375,12.01375,0,0,0,12-12V183.99951A4.0002,4.0002,0,0,0,216,179.99951Zm-176-32a4.0002,4.0002,0,0,0,4-4v-32a4,4,0,1,0-8,0v32A4.0002,4.0002,0,0,0,40,147.99951ZM72,212H48a4.00458,4.00458,0,0,1-4-4V183.99951a4,4,0,0,0-8,0V208a12.01375,12.01375,0,0,0,12,12H72a4,4,0,0,0,0-8ZM72,36H48A12.01375,12.01375,0,0,0,36,48V71.99951a4,4,0,0,0,8,0V48a4.00458,4.00458,0,0,1,4-4H72a4,4,0,0,0,0-8Z"></path>
        </svg>
    );
}

function NewNoteIcon() {
    return (
        <svg
            className="command-icon-note"
            width="18.5px"
            height="20px"
            viewBox="0 0 24 24"
            fill="none"
            style={{ marginLeft: '2px', marginRight: '1px', minWidth: '18.5px' }}
        >
            <path d="M5 4h14a1 1 0 0 1 1 1v9l-6 6H5a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1z" stroke="rgb(134, 145, 148)" strokeWidth="1.9" strokeLinejoin="round"></path>
            <path d="M14 20v-5a1 1 0 0 1 1-1h5" stroke="rgb(134, 145, 148)" strokeWidth="1.9" strokeLinejoin="round"></path>
        </svg>
    );
}

function ExportImageIcon() {
    // Path data from ControlsTopLeft's export menu (`icon-export-img`),
    // restyled from white-on-dark to the grey row-icon style.
    return (
        <svg
            className="command-icon-export"
            width="13px"
            height="20px"
            viewBox="0 0 32 32"
            fill="rgb(134, 145, 148)"
            // style={{ marginLeft: '5px', marginRight: '2px' }}
            style={{ marginLeft: '4px', marginRight: '4px' }}
        >
            <g><g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd"> <g transform="translate(-360.000000, -99.000000)" fill="rgb(134, 145, 148)"> <path d="M368,109 C366.896,109 366,108.104 366,107 C366,105.896 366.896,105 368,105 C369.104,105 370,105.896 370,107 C370,108.104 369.104,109 368,109 L368,109 Z M368,103 C365.791,103 364,104.791 364,107 C364,109.209 365.791,111 368,111 C370.209,111 372,109.209 372,107 C372,104.791 370.209,103 368,103 L368,103 Z M390,116.128 L384,110 L374.059,120.111 L370,116 L362,123.337 L362,103 C362,101.896 362.896,101 364,101 L388,101 C389.104,101 390,101.896 390,103 L390,116.128 L390,116.128 Z M390,127 C390,128.104 389.104,129 388,129 L382.832,129 L375.464,121.535 L384,112.999 L390,118.999 L390,127 L390,127 Z M364,129 C362.896,129 362,128.104 362,127 L362,126.061 L369.945,118.945 L380.001,129 L364,129 L364,129 Z M388,99 L364,99 C361.791,99 360,100.791 360,103 L360,127 C360,129.209 361.791,131 364,131 L388,131 C390.209,131 392,129.209 392,127 L392,103 C392,100.791 390.209,99 388,99 L388,99 Z" fill="rgb(134, 145, 148)" stroke="rgb(134, 145, 148)"> </path> </g> </g> </g>
        </svg>
    );
}

function ExportSqlIcon() {
    // Path data from ControlsTopLeft's export menu (`icon-export-code`),
    // restyled from white to the grey row-icon style.
    return (
        <svg
            className="command-icon-export-sql"
            width="17px"
            height="20px"
            viewBox="0 0 24 24"
            fill="none"
            // style={{ marginLeft: '3px' }}
            style={{ marginLeft: '2px', marginRight: '1px' }}
        >
            <g> <path d="M7 8L3 11.6923L7 16M17 8L21 11.6923L17 16M14 4L10 20" stroke="rgb(134, 145, 148)" strokeWidth="1.8px" strokeLinecap="round" strokeLinejoin="round"></path> </g>
        </svg>
    );
}

function GridStyleIcon() {
    // Path data from ControlsTopLeft's grid-style button, restyled to the
    // grey row-icon fill.
    return (
        <svg
            className="command-icon-grid-style"
            width="16px"
            height="20px"
            viewBox="1 0 48 48"
            fill="rgb(134, 145, 148)"
            style={{ marginLeft: '4px', marginRight: '1px' }}
        >
            <g><path d="M44,26a2,2,0,0,0,0-4H38V14h6a2,2,0,0,0,0-4H38V4a2,2,0,0,0-4,0v6H26V4a2,2,0,0,0-4,0v6H14V4a2,2,0,0,0-4,0v6H4a2,2,0,0,0,0,4h6v8H4a2,2,0,0,0,0,4h6v8H4a2,2,0,0,0,0,4h6v6a2,2,0,0,0,4,0V38h8v6a2,2,0,0,0,4,0V38h8v6a2,2,0,0,0,4,0V38h6a2,2,0,0,0,0-4H38V26ZM34,14v8H26V14ZM14,14h8v8H14Zm0,20V26h8v8Zm20,0H26V26h8Z"></path></g>
        </svg>
    );
}

function FocusModeIcon() {
    // Path data from ControlsBottom's focus-mode button (the "enter
    // fullscreen" state svg), restyled to the grey row-icon style.
    return (
        <svg className="command-icon-focus" width="20px" height="20px" viewBox="0 0 24 24" fill="none"><g> <path d="M21.7092 2.29502C21.8041 2.3904 21.8757 2.50014 21.9241 2.61722C21.9727 2.73425 21.9996 2.8625 22 2.997L22 3V9C22 9.55228 21.5523 10 21 10C20.4477 10 20 9.55228 20 9V5.41421L14.7071 10.7071C14.3166 11.0976 13.6834 11.0976 13.2929 10.7071C12.9024 10.3166 12.9024 9.68342 13.2929 9.29289L18.5858 4H15C14.4477 4 14 3.55228 14 3C14 2.44772 14.4477 2 15 2H20.9998C21.2749 2 21.5242 2.11106 21.705 2.29078L21.7092 2.29502Z" fill="rgb(134, 145, 148)" stroke="rgb(134, 145, 148)" strokeWidth="0.2px"></path> <path d="M10.7071 14.7071L5.41421 20H9C9.55228 20 10 20.4477 10 21C10 21.5523 9.55228 22 9 22H3.00069L2.997 22C2.74301 21.9992 2.48924 21.9023 2.29502 21.7092L2.29078 21.705C2.19595 21.6096 2.12432 21.4999 2.07588 21.3828C2.02699 21.2649 2 21.1356 2 21V15C2 14.4477 2.44772 14 3 14C3.55228 14 4 14.4477 4 15V18.5858L9.29289 13.2929C9.68342 12.9024 10.3166 12.9024 10.7071 13.2929C11.0976 13.6834 11.0976 14.3166 10.7071 14.7071Z" fill="rgb(134, 145, 148)" stroke="rgb(134, 145, 148)" strokeWidth="0.2px"></path> </g></svg>
    );
}

function MinimapIcon() {
    // Path data from components/Icon's `MiniMapIcon` (used by ControlsBottom's
    // minimap button).
    return (
        <svg className="command-icon-minimap" width="20px" height="20px" viewBox="0 0 24 24" fill="none"><g><path d="M9 18L2 22V6L9 2M9 18L16 22M9 18V2M16 22L22 18V2L16 6M16 22V6M16 6L9 2" stroke="rgb(134, 145, 148)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"></path></g></svg>
    );
}

function KeyboardShortcutsIcon() {
    // Path data from ControlsTopLeft's settings menu (`control-icon-keyboard-top`).
    return (
        <svg className="command-icon-keyboard" width="20px" height="20px" viewBox="0 0 24 24" fill="none"><g> <path d="M7 14H17M6 10H6.01M10 10H10.01M14 10H14.01M18 10H18.01M5.2 18H18.8C19.9201 18 20.4802 18 20.908 17.782C21.2843 17.5903 21.5903 17.2843 21.782 16.908C22 16.4802 22 15.9201 22 14.8V9.2C22 8.0799 22 7.51984 21.782 7.09202C21.5903 6.71569 21.2843 6.40973 20.908 6.21799C20.4802 6 19.9201 6 18.8 6H5.2C4.07989 6 3.51984 6 3.09202 6.21799C2.71569 6.40973 2.40973 6.71569 2.21799 7.09202C2 7.51984 2 8.07989 2 9.2V14.8C2 15.9201 2 16.4802 2.21799 16.908C2.40973 17.2843 2.71569 17.5903 3.09202 17.782C3.51984 18 4.0799 18 5.2 18Z" stroke="rgb(134, 145, 148)" strokeWidth="2px" strokeLinecap="round" strokeLinejoin="round"></path> </g></svg>
    );
}

function SendFeedbackIcon() {
    // Path data from ControlsTopRight's comment/chat-bubble svg (the
    // feedback button there is text-only — this is the closest svg in the
    // same file), restyled to the grey row-icon style.
    return (
        <svg className="command-icon-feedback" width="20px" height="20px" viewBox="0 0 24 24" fill="rgb(134, 145, 148)">
            <g><path d="M20,20h-4c-0.6,0-1-0.4-1-1s0.4-1,1-1h4c1.1,0,2-0.9,2-2V4c0-1.1-0.9-2-2-2H4C2.9,2,2,2.9,2,4v12c0,1.1,0.9,2,2,2h4 c0.6,0,1,0.4,1,1s-0.4,1-1,1H4c-2.2,0-4-1.8-4-4V4c0-2.2,1.8-4,4-4h16c2.2,0,4,1.8,4,4v12C24,18.2,22.2,20,20,20z"></path></g>
            <g><path d="M12,24c-0.3,0-0.5-0.1-0.7-0.3l-4-4c-0.4-0.4-0.4-1,0-1.4s1-0.4,1.4,0l3.3,3.3l3.3-3.3c0.4-0.4,1-0.4,1.4,0s0.4,1,0,1.4 l-4,4C12.5,23.9,12.3,24,12,24z"></path></g>
            <g><path d="M18,7H6C5.4,7,5,6.6,5,6s0.4-1,1-1h12c0.6,0,1,0.4,1,1S18.6,7,18,7z"></path></g>
            <g><path d="M13,11H6c-0.6,0-1-0.4-1-1s0.4-1,1-1h7c0.6,0,1,0.4,1,1S13.6,11,13,11z"></path></g>
            <g><path d="M16,15H6c-0.6,0-1-0.4-1-1s0.4-1,1-1h10c0.6,0,1,0.4,1,1S16.6,15,16,15z"></path></g>
        </svg>
    );
}

// commandId -> icon component. Covers every id currently in
// src/lib/search/commands.js (active and user-commented) so trimming/
// restoring the registry there never needs a matching edit here.
export const COMMAND_ICONS = {
    'new-table': PlusIcon,
    'new-line': NewLineIcon,
    'new-area': NewAreaIcon,
    'new-note': NewNoteIcon,
    'export-image': ExportImageIcon,
    'export-sql': ExportSqlIcon,
    'grid-style': GridStyleIcon,
    'focus-mode': FocusModeIcon,
    'minimap': MinimapIcon,
    'keyboard-shortcuts': KeyboardShortcutsIcon,
    'send-feedback': SendFeedbackIcon,
};

export default COMMAND_ICONS;
